import { AppAlert } from '@components/antd';
import { AppModal } from '@components/form/Modal';
import { Modal } from 'antd';
import { RiPhoneFill } from 'react-icons/ri';
import { useSwitchCallBanner } from './hooks/use-switch-call-banner';

export const SwitchCallBanner = () => {
  const { loading, switchModal, handleSwitchCall } = useSwitchCallBanner();
  return (
    <>
      <AppAlert
        showIcon
        type="success"
        icon={<RiPhoneFill size={20} />}
        message={
          <p className="text-sm">
            You’re currently on an active call on another device.{' '}
            <a className="font-semibold  underline! underline-offset-2!" onClick={switchModal.handleOpen}>
              Switch call to this device
            </a>
          </p>
        }
      />

      <Modal
        classNames={{ content: '!max-w-[420px]' }}
        centered
        open={switchModal.open}
        onCancel={switchModal.handleClose}
        title={
          <AppModal.Header>
            <AppModal.Title>Switch call to this device</AppModal.Title>
          </AppModal.Header>
        }
        footer={
          <AppModal.Footer>
            <AppModal.Button className="w-full" onClick={switchModal.handleClose}>
              Cancel
            </AppModal.Button>
            <AppModal.Button className="w-full" type="primary" onClick={handleSwitchCall} loading={loading}>
              Switch
            </AppModal.Button>
          </AppModal.Footer>
        }
      >
        <AppModal.Body>
          <p>Are you sure you want to switch? The call on your current device will be put on hold.</p>
        </AppModal.Body>
      </Modal>
    </>
  );
};
